module.exports = __webpack_public_path__ + "static/steel-section-geometry-880x880-45f811a4d9847c97155a0e6d7ef0477d.png";